import React, { useEffect, useState } from 'react'

import "./styles.scss"
import { showToast, startLoading, stopLoading } from '../../services/common-service'
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types'

import { IframeMessageProxy } from 'iframe-message-proxy'
import IMPContainer from '../../constants/iframe-message-proxy-container';

import { v4 as uuid } from 'uuid';
import Upload from '../Input/Upload'
import Alert from '../Alert'

export default function ModalImportItems({
    opened,
    setOpened,
    resource,
    getResource,
    setItems
}) {
    const [itemsUpload, setItemsUpload] = useState([])
    const [error, setError] = useState(null)

    const [alertOpened, setAlertOpened] = useState(false)
    const [alert, setAlert] = useState({})

    useEffect(() => {
        if (!opened) {
            setItemsUpload([])
            setError(null)
        }
    }, [opened])

    const close = () => {
        setOpened(() => null)
    }

    const submit = async () => {
        try {
            startLoading()
            setError(() => null)

            if (itemsUpload.length == 0)
                throw { message: "Nenhum item foi inserido" }

            let newItems = []

            try {
                const result = await getResource(resource.key, "items")
                console.log(result)

                newItems = result?.items
            } catch (error) {
                throw error
            }

            // Verificar registros com ID iguais
            if (itemsUpload.some(item => newItems.some(item2 => item2._id == item._id))) {
                setAlertOpened(() => true)
                setAlert({
                    header: "Atenção!",
                    body: "Encontramos registros com ID idênticos. Como deseja continuar?",
                    actions: [
                        {
                            variant: "secondary",
                            bold: "true",
                            title: "Cancelar importação",
                            onClick: () => setAlertOpened(false)
                        },
                        {
                            variant: "primary",
                            bold: "true",
                            title: "Substituir pelos novos",
                            onClick: async () => {
                                for (let item of itemsUpload) {
                                    let index = newItems.findIndex(item2 => item2._id == item._id)
                                    if (index >= 0) {
                                        newItems.splice(index, 1)
                                    }
                                }

                                setAlertOpened(false)
                                upload([...newItems, ...itemsUpload])
                            }
                        },
                        {
                            variant: "primary",
                            bold: "true",
                            title: "Manter os já registrados",
                            onClick: async () => {
                                let newItemsUpload = []

                                for (let item of itemsUpload) {
                                    let index = newItems.findIndex(item2 => item2._id == item._id)
                                    if (index < 0) {
                                        newItemsUpload.push(item)
                                    }
                                }

                                setAlertOpened(false)
                                upload([...newItems, ...newItemsUpload])
                            }
                        }
                    ]
                })
            } else
                upload([...newItems, ...itemsUpload])
        } catch (error) {
            // console.error(error)
            setError(() => error?.message)
            showToast({
                type: BlipPortalToastTypes.DANGER,
                message: error?.message || "Ocorreu um erro"
            });
        } finally {
            stopLoading()
        }
    }

    const upload = async (newItems) => {
        await IframeMessageProxy.sendMessage({
            action: IMPContainer.Actions.SEND_COMMAND,
            content: {
                command: {
                    method: IMPContainer.CommandMethods.SET,
                    uri: `/resources/${resource.key}`,
                    type: "application/json",
                    resource: { items: newItems }
                },
                // destination: IMPContainer.Destinations.BLIP_SERVICE
            }
        });

        setItems(newItems)
        close()
    }

    const onChangeUpload = (event) => {
        let files = event.detail.value

        if (files.length == 0)
            return

        let file = files[0]

        const reader = new FileReader();

        reader.onload = (e) => {
            const content = e.target.result;
            importDocument(content)
        };

        reader.readAsText(file);
    }

    const importDocument = (object) => {
        try {
            object = JSON.parse(object)
            if (typeof object != "object") throw { message: "Erro no envio. Confira seu arquivo" }
            if (!object.items) throw { message: `O arquivo deve possuir o atributo "items"` }
            if (!Array.isArray(object.items)) throw { message: `O parâmetro "items" deve possuir um array` }

            let { items } = object

            for (let item of items) {
                if (!item._id)
                    item._id = uuid()
            }

            setItemsUpload(items)
        } catch (error) {
            console.error(error)
            showToast({
                type: BlipPortalToastTypes.DANGER,
                message: error?.message || "Ocorreu um erro"
            });
        }
    }

    return (
        <>
            <bds-modal open={opened} close-button="false" size="dynamic">
                <div className="modal-resources">
                    <div className="modal-body">

                        <Upload
                            accept=".json"
                            error={error}
                            multiple={false}
                            titleName="Arquivo JSON"
                            subtitle={`Utilize um arquivo de importação. É necessário que o array esteja no atributo "itens"`}
                            onChange={onChangeUpload}
                        />

                    </div>

                    {/* {JSON.stringify(data)} */}

                    {/* <bds-modal-action> */}
                    <div className="flex justify-end" style={{ width: "100%", zIndex: 0 }}>
                        <bds-button variant="secondary" onClick={close}>Cancelar</bds-button>
                        <bds-button onClick={submit} disabled={itemsUpload.length == 0}>Pronto</bds-button>
                    </div>
                    {/* </bds-modal-action> */}
                </div>
            </bds-modal>

            <Alert
                opened={alertOpened}
                setAlert={setAlert}
                {...alert}
            />
        </>
    )
}